import React from 'react';

import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';
import LoadingSpinner from 'components/ui/loading_spinner';

import type { ActionVerdict, AssistantAction, AssistantActionStatus } from './types';

const RESOLVED_LABELS: Partial<Record<AssistantActionStatus, string>> = {
  applied: 'Accepted',
  failed: "Couldn't be applied",
  rejected: 'Rejected',
  stale: 'This proposal is out of date',
};

interface Props {
  actions: AssistantAction[];
  disabled: boolean;
  onResolve: (action: AssistantAction, verdict: ActionVerdict) => void;
}

export default function ActionConfirmations({ actions, disabled, onResolve }: Props) {
  return (
    <>
      {actions.map(action => (
        <div className="mt-1" key={action.id}>
          {action.status === 'pending' && (
            <div className="d-flex gap-2">
              <Button
                disabled={disabled}
                icon={faCheck}
                label="Accept"
                size="sm"
                variant="outline"
                onClick={() => onResolve(action, 'apply')}
              />
              <Button
                disabled={disabled}
                icon={faXmark}
                label="Reject"
                size="sm"
                variant="ghost"
                onClick={() => onResolve(action, 'reject')}
              />
            </div>
          )}
          {action.status === 'applying' && (
            <div className="d-flex align-items-center gap-2 text-muted small">
              <LoadingSpinner inline size="sm" />
              <span>Applying…</span>
            </div>
          )}
          {RESOLVED_LABELS[action.status] && (
            <div className="text-muted small">{RESOLVED_LABELS[action.status]}</div>
          )}
        </div>
      ))}
    </>
  );
}
